export enum CodigoTipoItbiAise {
  FINANCIADO = 2,
  COM_ANUENCIA = 3,
  ISENCAO = 6
}
